import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import ReduxToastr from 'react-redux-toastr'
import debounce from 'lodash/debounce'
import { Route } from 'react-router-dom'
import { getFormMeta, getFormNames, isDirty } from 'redux-form/immutable'
import * as ROLES from 'app/constants/roles'
import * as STAGES from 'app/constants/stages'
import Launch from './common/Launch'
import Modal from './common/Modal'
import Header from './Header'
import AsyncRouter from './AsyncRouter'
import { getDimensions } from 'helpers/multibrowserHelper'
import Reports from 'app/domains/routes/Reports'
import ReviewsSurveyQuestions from 'app/domains/routes/ReviewsSurveyQuestions'
import { history, store } from 'store'
import { CREATE_PROTRACK_FORM_NAME, EDIT_PROTRACK_FORM_NAME } from 'app/constants/protracks'
import { CREATE_LEVEL_FORM_NAME, EDIT_LEVEL_FORM_NAME } from 'app/constants/levels'
import { ACTIVITIES_LIST_FORM_NAME, CREATE_ACTIVITY_FORM_NAME, EDIT_ACTIVITY_FORM_NAME } from 'app/constants/activities'
import { getTouchedActivities, getTouchedLevels } from 'store/entities/protracks/unsavedChanges/selectors'
import { isOpen } from 'store/entities/modal/selectors'
import { cutAddressBeforeLaunchAtUrl } from 'helpers/urlHelper.js'
import { LAUNCH_PATH, REVIEWS_SURVEY_PATH, REVIEWS_REPORT, START_PATH } from 'app/constants/navLinks'

import './styles.scss'

const ADD_NEW_ACTIVITY_PATH = '/activities/new'

class App extends Component {
  static propTypes = {
    role: PropTypes.string,
    stage: PropTypes.string,
    pathname: PropTypes.string,
    changeWindowSizes: PropTypes.func.isRequired,
    showConfirmationModal: PropTypes.func.isRequired,
  }

  state = {
    headerHeight: 0,
  }

  componentDidMount() {
    this.resize = debounce(this.resizeHandler, 500)
    window.addEventListener('resize', this.resize)
    this.resizeHandler()

    // TODO: @Serginyo90 must to rewrite logic. Issue is that we select first form from store but there can be more than one form
    history.block(location => {
      // go forward if forceLeave === true
      if (location.state && location.state.forceLeave) {
        return true
      }
      const state = store.getState()
      const formNames = getFormNames()(state)
      const currentFormName = formNames.get(0)
      // go forward if form doesn't exist
      if (!currentFormName) {
        return true
      }
      const isDirtyForm = isDirty(currentFormName)(state)
      let isFormTouched = false
      const formMeta = getFormMeta(currentFormName)(state)
      const areLevelsTouched = getTouchedLevels(state)
      switch (currentFormName) {
        case CREATE_PROTRACK_FORM_NAME:
          isFormTouched =
            formMeta.getIn(['name', 'touched']) ||
            formMeta.getIn(['label', 'touched']) ||
            formMeta.getIn(['publicName', 'touched'])
          break
        case EDIT_PROTRACK_FORM_NAME:
          isFormTouched =
            formMeta.getIn(['name', 'touched']) ||
            formMeta.getIn(['label', 'touched']) ||
            formMeta.getIn(['publicName', 'touched']) ||
            areLevelsTouched
          break
        case ACTIVITIES_LIST_FORM_NAME:
          isFormTouched = getTouchedActivities(state)
          break
        case CREATE_LEVEL_FORM_NAME:
        case EDIT_LEVEL_FORM_NAME:
        case CREATE_ACTIVITY_FORM_NAME:
        case EDIT_ACTIVITY_FORM_NAME:
          isFormTouched = isDirtyForm
          break
      }
      if (isFormTouched) {
        this.props.setBlockedPathname(location.pathname)
        this.props.showConfirmationModal()
        return false
      }
      // !(location.state && location.state.isFromGenerator) is hack. Because app closing popup when try to Edit Activities after generating http://joxi.ru/DmBBZeLc4z5wVm?d=1
      //  TODO: @rastym Find better solution for that issue https://github.com/prohabits/prohabits-ui/issues/3444
      if (isOpen(state) && !(location.state && location.state.isFromGenerator)) {
        //  Statement below was added to prevent modal hide after loading activities from cvs #3444
        if (location.pathname.includes(ADD_NEW_ACTIVITY_PATH)) return
        this.props.hideModal()
      }
    })
  }

  componentWillUnmount() {
    if (this.resize) {
      window.removeEventListener('resize', this.resize)
    }
  }

  resizeHandler = () => {
    const { width, height } = getDimensions()
    this.props.changeWindowSizes(width, height)
  }

  setHeight = headerHeight => {
    if (this.state.headerHeight !== headerHeight) {
      this.setState({ headerHeight })
    }
  }

  render() {
    const {
      role,
      stage,
      isUser,
      location: { pathname },
    } = this.props
    // for login with extra characters before launch?hash=
    if (pathname.includes(LAUNCH_PATH) && pathname.indexOf(LAUNCH_PATH) !== 1) {
      location.pathname = cutAddressBeforeLaunchAtUrl(pathname)
    }
    // @Serginyo90 Temporary fix for SendGrid until issue will be resolved
    if (location.href.includes('url5123')) {
      location.href = 'https://demo.prohabits.com/login'
    }
    const { headerHeight } = this.state
    const isNotReportsPage = pathname.indexOf('reports') === -1
    const isNotReviewsSurveyPage = pathname.indexOf('reviews-survey') === -1
    const showHeader =
      !['/on-boarding-landing', START_PATH, '/launch', '/login'].includes(pathname) &&
      isNotReportsPage &&
      isNotReviewsSurveyPage
    const isDone = stage === STAGES.DONE && isUser
    const isProTrackPalette = pathname.indexOf('/protrack') === 0
    return (
      <div className="wrapper" style={{ paddingTop: headerHeight }}>
        {showHeader && <Header setHeight={this.setHeight} />}
        <div
          className={classNames('container', {
            'container--stage-selection': isDone && isProTrackPalette,
          })}
        >
          <main
            className={classNames('content', {
              'content--stage-selection': isDone && isProTrackPalette,
              'content--on-boarding': ~pathname.indexOf('/on-boarding'),
              'content--super-admin':
                (!~pathname.indexOf(REVIEWS_SURVEY_PATH) &&
                  [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MULTI_ADMIN].includes(role)) ||
                !pathname.indexOf(REVIEWS_REPORT),
            })}
          >
            {pathname === '/launch' ? (
              <Route path="/launch" component={Launch} />
            ) : pathname === '/reports' ? (
              <Route path="/reports" component={Reports} />
            ) : pathname.includes(REVIEWS_SURVEY_PATH) ? (
              <Route path={REVIEWS_SURVEY_PATH} component={ReviewsSurveyQuestions} />
            ) : (
              <AsyncRouter />
            )}
          </main>
        </div>
        <div id="toastr">
          <ReduxToastr
            newestOnTop
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            progressBar={false}
            getState={state => state.get('toastr')}
            closeOnToastrClick
          />
        </div>
        <Modal />
      </div>
    )
  }
}

export default App
